import { STOP_CURRENT, STOP_DONE, STOP_TO_DO } from '../TimelineStopGraphic';

export const validateIndex = (index: number, array: string[]) => {
  if (index > array.length - 1 || index < 0) {
    throw new Error(`Index ${index} out of bounds for array ${array}`);
  }
};

export const getPickupProperties = (pickupIndex: number, currentStopIndex: number, pickups: string[]) => {
  validateIndex(pickupIndex, pickups);
  if (currentStopIndex > pickups.length - 1) {
    return STOP_DONE;
  }
  if (pickupIndex > currentStopIndex) {
    return STOP_TO_DO;
  } else if (pickupIndex < currentStopIndex) {
    return STOP_DONE;
  } else if (pickupIndex === currentStopIndex) {
    return STOP_CURRENT;
  } else {
    return STOP_TO_DO;
  }
};

export const getPickupLabels = (pickupIndex: number, currentStopIndex: number, pickups: string[]) => {
  validateIndex(pickupIndex, pickups);
  const label = pickups.length > 1 ? `Pickup ${pickupIndex + 1}` : 'Pickup';
  if (pickupIndex === currentStopIndex) {
    return {
      label: label,
      sublabel: pickups[pickupIndex],
    };
  } else {
    return {
      label: label,
      sublabel: pickups.length > 1 ? '' : pickups[pickupIndex],
    };
  }
};

export const getDropoffProperties = (
  dropoffIndex: number,
  currentStopIndex: number,
  numPickups: number,
  dropoffs: string[],
) => {
  validateIndex(dropoffIndex, dropoffs);
  const shiftedIndex = numPickups + dropoffIndex;
  if (shiftedIndex > currentStopIndex) {
    return STOP_TO_DO;
  } else if (shiftedIndex < currentStopIndex) {
    return STOP_DONE;
  } else if (shiftedIndex === currentStopIndex) {
    return STOP_CURRENT;
  } else {
    return STOP_TO_DO;
  }
};

export const getDropoffLabels = (dropoffIndex: number, dropoffs: string[]) => {
  validateIndex(dropoffIndex, dropoffs);
  return {
    label: dropoffs.length > 1 ? `Drop-Off ${dropoffIndex + 1}` : 'Drop-Off',
    sublabel: dropoffs[dropoffIndex],
  };
};
